export const privacyPolicyData = {
  title: "Privacy Policy",
  effectiveDate: "21st December 2024",
  sections: [
    {
      title: "Introduction",
      content: "Welcome to ashopiy. We are committed to protecting your privacy and ensuring that your personal information is secure. This Privacy Policy explains how we collect, use, and disclose information when you use our website and services."
    },
    {
      title: "Information We Collect",
      content: "We collect the following types of information:",
      list: [
        { type: "strong", text: "Personal Information:" },
        { text: "such as your name, email address, phone number, and payment information." },
        { type: "strong", text: "Usage Information:" },
        { text: "such as your IP address, browser type, and activity on our website." },
        { type: "strong", text: "Cookies:" },
        { text: "to improve your experience on our site and analyze website traffic." }
      ]
    },
    {
      title: "How We Use Your Information",
      content: "We use the information we collect to:",
      list: [
        { text: "Provide, maintain, and improve our services." },
        { text: "Process transactions and send you updates related to your orders." },
        { text: "Respond to your inquiries and provide customer support." },
        { text: "Analyze usage patterns and improve user experience." }
      ]
    },
    {
      title: "Sharing of Information",
      content: "We do not sell or rent your personal information to third parties. We may share your information with trusted partners for the following purposes:",
      list: [
        { text: "Payment processing through secure third-party providers." },
        { text: "Providing customer service through trusted service providers." },
        { text: "Legal obligations, such as complying with court orders or legal processes." }
      ]
    },
    {
      title: "Data Security",
      content: "We implement robust security measures to protect your personal information from unauthorized access, disclosure, or misuse. However, please be aware that no method of online transmission is 100% secure."
    },
    {
      title: "Your Rights",
      content: "You have the right to access, update, or delete your personal information. If you wish to exercise these rights, please contact us at info.ashopiy@gmail.com."
    },
    {
      title: "Changes to this Privacy Policy",
      content: "We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting a notice on our website."
    },
    {
      title: "Contact Us",
      content: "If you have any questions about this Privacy Policy, please contact us at info.ashopiy@gmail.com."
    }
  ]
};

export const shippingPolicyData = {
  title: "Shipping Policy",
  content: [
    "Thank you for visiting ashopiy. Please note that we currently do not sell any physical products on our platform. As such, we do not have a shipping policy in place at this time.",
    "Our platform is dedicated to providing services to shopkeepers and business owners to help them manage their revenue, earnings, and investments effectively. If you are a shopkeeper using our services, you can continue to rely on our tools and resources to streamline your business operations.",
    "Should we expand our offerings to include physical products in the future, we will update this page with a comprehensive shipping policy outlining delivery procedures, timelines, and associated costs."
  ]
};

export const termsConditionsData = {
  title: "Terms & Conditions",
  effectiveDate: "21st December 2024",
  sections: [
    {
      title: "Introduction",
      content: "These Terms & Conditions govern your use of our website and services. By accessing or using our services, you agree to comply with these terms. Please read them carefully."
    },
    {
      title: "Use of the Website",
      content: "You agree to use the website only for lawful purposes. You must not use our services in any way that breaches any applicable law or regulation or causes harm to others.",
      list: [
        { text: "Do not misuse the services by interfering with their normal operation." },
        { text: "You may not attempt to gain unauthorized access to our systems." },
        { text: "Do not use the website to transmit any malware or harmful software." }
      ]
    },
    {
      title: "Account Registration",
      content: "If you create an account with us, you must provide accurate and complete information. You are responsible for maintaining the confidentiality of your account credentials.",
      additionalContent: "You agree to notify us immediately if there is any unauthorized use of your account."
    },
    {
      title: "Payments and Refunds",
      content: "All payments made through our website are processed securely. Fees, charges, and any applicable taxes will be displayed before you complete a purchase.",
      additionalContent: "Refunds may be provided in accordance with our refund policy, which is detailed separately."
    },
    {
      title: "Intellectual Property",
      content: "All content on our website, including text, graphics, logos, and software, is the property of ashopiy. You are not allowed to copy, modify, or distribute any part of our website without permission."
    },
    {
      title: "Limitation of Liability",
      content: "We are not responsible for any damages that arise from your use of our website, including loss of data, profits, or business. Our liability is limited to the extent permitted by law."
    },
    {
      title: "Termination of Service",
      content: "We reserve the right to terminate or suspend your access to our website at any time if you breach these Terms & Conditions or engage in unlawful activities."
    },
    {
      title: "Changes to the Terms",
      content: "We may update these Terms & Conditions from time to time. We will notify you of significant changes by posting an update on our website. Continued use of the website after changes are made constitutes your acceptance of the new terms."
    },
    {
      title: "Governing Law",
      content: "These Terms & Conditions are governed by and construed in accordance with the laws of India. Any disputes relating to these terms will be subject to the jurisdiction of the courts in Gharuan."
    },
    {
      title: "Contact Us",
      content: "If you have any questions about these Terms & Conditions, please contact us at info.ashopiy@gmail.com."
    }
  ]
};

export const faqs = [
    {
      question: 'What is the purpose of this platform?',
      answer: 'Our platform is designed to help shopkeepers and small, medium & large business owners manage their Investments, track earnings, and improve their overall business operations.',
    },
    {
      question: 'How do I sign up for a plan?',
      answer: 'You can sign up for a plan by navigating to the pricing section, choosing a suitable plan, and following the steps to complete your registration.',
    },
    {
      question: 'What payment methods are accepted?',
      answer: 'We accept credit cards, debit cards, UPI, and other payment gateways through Razorpay. All transactions are secure and encrypted.',
    },
    {
      question: 'Is there a free trial available?',
      answer: 'Currently, we are offering free access to our platform until February 27th as a special benefit for new users. While we do not typically provide a free trial, our platform is designed with budget-friendly pricing to ensure accessibility for shopkeepers of all sizes, whether managing a small business or a larger operation.',
    },
    {
      question: 'How can I contact support?',
      answer: 'You can contact our support team by emailing info.ashopiy@gmail.com or using the live chat feature on our whatsApp No. We are here to help 24/.',
    },
  ];